export default "__VITE_PUBLIC_ASSET__57753793__"